"use client";

import Translations from "@translate/components/EmailLogin/shared/ResendCodeRow";
import React from "react";
import { cn } from "utils";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

interface ResendCodeRowProps {
  resendCountdown: number;
  onResend: () => void;
  codeError?: boolean;
  className?: string;
}

export function ResendCodeRow({
  resendCountdown,
  onResend,
  codeError = false,
  className,
}: ResendCodeRowProps) {
  const canResend = resendCountdown <= 0;

  return (
    <div
      className={cn("flex items-center gap-2", codeError && "mt-1", className)}
    >
      <p className="body_m text-content_secondary">{I18n.t("No email?")}</p>
      <button
        aria-label="Code Verify Step"
        data-openreplay-label="login_codeverifystep_submit"
        id="btn-code-verify-step"
        type="button"
        disabled={!canResend}
        onClick={onResend}
        className="body_medium_m text-content_brand_primary disabled:cursor-not-allowed disabled:text-content_primary"
      >
        {resendCountdown > 0
          ? I18n.t("Resend in %{var0}", { var0: resendCountdown })
          : I18n.t("Resend")}
      </button>
    </div>
  );
}
